import React, {useEffect, useState} from 'react';
import {Button, Modal} from "antd";
import LightGallery from "lightgallery/react";
import lgThumbnail from "lightgallery/plugins/thumbnail";
import lgZoom from "lightgallery/plugins/zoom";

// import styles
import 'lightgallery/css/lightgallery.css';
import 'lightgallery/css/lg-zoom.css';
import 'lightgallery/css/lg-thumbnail.css';

// If you want you can use SCSS instead of css
import 'lightgallery/scss/lightgallery.scss';
import 'lightgallery/scss/lg-zoom.scss';
import axios from "axios";
import {API_PATH} from "../../components/const";

// import plugins if you need

const SupportViewModal = (props) => {

    const [sendData, setSendData] = useState({})
    const setStatus = (status) => {
        let data = new FormData()
        data.append("title", props?.selectItem?.title)
        data.append("description", props?.selectItem?.description)
        data.append("image_url", props?.selectItem?.image_url)
        data.append("priority", props?.selectItem?.priority)
        data.append("status", status)
        data.append("created_by_user_id", props?.selectItem?.created_by_user_id)
        // data.append("assigned_to_user_id", props?.selectItem?.assigned_to_user_id)
        data.append("category", props?.selectItem?.category)
        data.append("updated_at", props?.selectItem?.updated_at)
        data.append("user", props?.selectItem?.user)
        data.append("assigned_user", props?.selectItem?.assigned_user)
        axios.put(API_PATH + "company/" + localStorage.getItem('id') + "/ticket/" + props?.selectItem?.id,   data, {headers: {"Authorization": "Bearer " + localStorage.getItem("token")}})
            .then(res =>{
                props.setIsModalOffice(false)
                props.getDataInProgress()
                props.getDataApp()
                props.getDataInTest()
                props.getDataDone()
            })
    }
    const onInit = () => {

    };
    useEffect(() =>{
        // console.log(props?.selectItem?.image_url != null)
    }, [])

    return (
        <Modal title="View application"
               open={props.isModalOffice}
               onCancel={() => props.setIsModalOffice(false)}
               width={640}
               footer={[
                   <div>
                       {
                           props?.type === "application"
                           ?
                               <Button key="submit" type="primary" onClick={(e) => {
                                   props?.setSelectItem({...props?.selectItem, status: "in_progress"})
                                   setStatus("in_progress")
                               }}>
                                   In Progress
                               </Button>
                           :
                           props?.type === "in_progress" ?
                                <Button key="submit" type="orange" onClick={(e) => {
                                    props?.setSelectItem({...props?.selectItem, status: "in_test"})
                                    setStatus("in_test")
                                }}>
                                    In test
                                </Button>
                               :
                                 props?.type === "in_test"
                                     ?
                                     <>
                                         <Button key="submit" type="primary" onClick={(e) => {
                                             props?.setSelectItem({...props?.selectItem, status: "in_progress"})
                                             setStatus("in_progress")
                                         }}>
                                             In Progress
                                         </Button>

                                         <Button key="submit" className="ml-8" type="success" onClick={(e) => {
                                             props?.setSelectItem({...props?.selectItem, status: "done"})
                                             setStatus("done")
                                         }}>
                                            Done
                                         </Button>
                                     </>
                           :
                                 props?.type === "done"
                                     ?
                                     <>
                                     <Button key="submit" type="orange" onClick={(e) => {
                                         props?.setSelectItem({...props?.selectItem, status: "in_test"})
                                         setStatus("in_test")
                                     }}>

                                         In test
                                     </Button>

                                     </>
                           :
                           ""
                       }

                   </div>

               ]}
        >
            <div className="cam-add-modal">
                <div className="inputs-box">
                    <label className="font-family-medium">Text</label>
                    <textarea value={props?.selectItem?.title} onChange={(e) => props?.setSelectItem({...props?.selectItem, title: e.target.value})} />
                </div>
                {/*<div className="inputs-box">*/}
                {/*    <label className="font-family-medium">Image or file </label>*/}
                {/*    <input onChange={(e) => setSendData({...sendData, address: e.target.value})} type="file"/>*/}
                {/*</div>*/}

                {
                    props?.selectItem?.image_url !== null &&  props?.selectItem?.image_url !== "null"
                        ?
                        <LightGallery
                            onInit={onInit}
                            speed={100}
                            plugins={[lgThumbnail, lgZoom]}
                            className="d-flex flex-wrap"
                        >
                            <a href={props?.selectItem?.image_url} style={{width: "100%", height:  "200px",objectFit: "cover", marginRight: "10px", marginBottom: "10px", marginTop: "20px", display: "block"}}>
                                <img src={props?.selectItem?.image_url}  style={{width: "100%", height:  "200px",objectFit: "cover"}}/>
                            </a>

                        </LightGallery>
                        :
                       ""

                }


            </div>

        </Modal>
    );
};

export default SupportViewModal;